import { mount } from "svelte";
import type { Component } from "svelte";

type AnySvelteComponent = Component<Record<string, any>, Record<string, any>, any>;

const registry: Record<string, AnySvelteComponent> = {};

export function registerComponents(map: Record<string, AnySvelteComponent>) {
  Object.assign(registry, map);
}

function parseProps(el: HTMLElement): Record<string, unknown> {
  const raw = el.dataset.props;
  if (!raw) return {};

  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object") return parsed as Record<string, unknown>;
  } catch (err) {
    console.warn("Invalid JSON in data-props", el, err);
  }

  return {};
}

export function mountComponents(root: ParentNode = document) {
  const nodes = root.querySelectorAll<HTMLElement>("[data-component]");

  nodes.forEach((el) => {
    const name = el.dataset.component;
    if (!name) return;

    const Ctor = registry[name];
    if (!Ctor) {
      console.warn(`Svelte component not registered: ${name}`);
      return;
    }

    // Avoid double-mount if called multiple times.
    if ((el as unknown as { __svelte_mounted?: boolean }).__svelte_mounted) return;
    (el as unknown as { __svelte_mounted?: boolean }).__svelte_mounted = true;

    mount(Ctor, {
      target: el,
      props: parseProps(el),
    });
  });
}
